<div>
    <div class = "dialog-header-container">
        <h2 mat-dialog-title class="pd-t-5px">Cancel Meeting</h2>
        <div>            
            <button mat-icon-button mat-dialog-close (click)="closeDialog()"><mat-icon>close</mat-icon></button>
        </div>
    </div>
    <mat-divider class="mat-divider"></mat-divider>
    <form>
        <div mat-dialog-content class="dialog-with-actions">
            <div class="col-md-12" [ngStyle]="{'margin-top':'18px'}">
                <mat-form-field class="col-md-12 para-container input-field-formatting body-font-size" [ngStyle]="{'width':'100%'}">
                    <!-- <input class="body-font-size" type="text" id="deleteMeetingId" [(ngModel)]="reason"  matInput placeholder="Reason"  name="name" autocomplete="off"  > -->
                    <textarea matInput class="body-font-size" type="text" id="deleteMeetingId" [(ngModel)]="reason"  matInput placeholder="Reason"  name="name" autocomplete="off"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div mat-dialog-actions class="d-flex justify-content-end">
            <!-- <span><button class="button-container primary" type="button" mat-flat-button color="primary" (click)="cancelMeeting()">Save</button></span>&nbsp;&nbsp;
            <span> -->
                <button class="button-container primary" type="button" mat-flat-button color="primary" (click)="cancelMeeting()">
                    SAVE
                </button>
                <button type="button" #editModalClose mat-flat-button color="primary" class="button-container primary" (click)="closeDialog()">
                    CANCEL
                </button>
        </div>
    </form>
</div>